<script>
import { mapState } from 'vuex';
import { EN } from '@/locales';
import { nonCalendarPermission, SCHEDULE_TYPE, SCHEDULE_CUSTOMS_TYPE } from '@/hooks/calendar/useScheduleCore';
import { miniSafeGet } from '@/utils/api';
import { useCalendarCommon } from '@rebuild/materials/shared/customs_calendar/useCalendarCommon';

export default {
	props: {
		detail: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		...mapState({
			bilingual: state => state.conferenceDetailBilingual || 'zh'
		})
	},
	methods: {
		getCustomsType() {
			const { calendarVO, customsType: outType } = this.detail;
			const { customsType: innerType } = calendarVO;
			return outType || innerType;
		}
	},
	setup() {
		const { getCalendarName } = useCalendarCommon();
		return {
			getCalendarName
		};
	},
	render() {
		const composeIrstoreRows = () => {
			const rows = [];
			const customsType = this.getCustomsType();
			if (customsType === SCHEDULE_CUSTOMS_TYPE.ANNOUNCEMENT && this.$i18n.locale !== EN) {
				if (this.detail.announcementVO) {
					rows.push({
						label: this.$t('enterprise.datepicker.announcementType'),
						value: this.detail.announcementVO.annoClassif
					});
				}
			}

			return rows;
		};
		const composeRowContent = () => {
			const { type, calendarVO, investmentActivityType } = this.detail;
			const { isOwn, calendarName } = calendarVO;
			const customsType = this.getCustomsType();

			// 如他人日程查看权限为「游客」，只展示一个日历
			const isSubscribe = !isOwn;
			if (isSubscribe && nonCalendarPermission(calendarVO)) {
				return [
					{
						label: this.$t('enterprise.datepicker.calendar'),
						keyname: 'calendarName',
						value: calendarName
					}
				];
			}

			let scheduleRows = [];
			if (type === SCHEDULE_TYPE.CREATE) {
				scheduleRows.push({
					label: '日程描述',
					value: this.detail['scheduleDesc']
				});
			}

			let irstoreRows = [];
			if (type === SCHEDULE_TYPE.CUSTOMS_CALENDAR) {
				irstoreRows = composeIrstoreRows();
			}

			const typeLabelMap = {
				0: '沟通活动',
				1: '日程',
				2: '投关日历'
			};
			const typeForIR = {
				1: this.$t('enterprise.investment.roadshow'),
				2: this.$t('enterprise.investment.research'),
				3: this.$t('enterprise.investment.summary')
			};
			let otherRows = [];
			if (!nonCalendarPermission) {
				if (type === SCHEDULE_TYPE.CUSTOMS_CALENDAR) {
					if (customsType === SCHEDULE_CUSTOMS_TYPE.IRSTORE) {
						otherRows.push({
							label: this.$t('enterprise.datepicker.type'),
							value: typeForIR[investmentActivityType]
						});
					}
				} else {
					otherRows = [
						{
							label: this.$t('enterprise.datepicker.type'),
							value: typeLabelMap[type]
						}
					];
				}
			}

			let defaultRowMap = [
				{
					label: this.$t('enterprise.datepicker.calendar'),
					keyname: 'calendarVO.id'
				}
			];
			defaultRowMap = defaultRowMap.map(item => {
				const _item = { ...item };
				if (_item.keyname === 'calendarVO.id') {
					const calendarId = miniSafeGet(this.detail, item.keyname, '');
					_item.value = this.getCalendarName(calendarId);
				}
				return _item;
			});

			return [...irstoreRows, ...otherRows, ...defaultRowMap, ...scheduleRows];
		};
		const rowList = composeRowContent();

		return (
			<div class="c-schedule-wrapper">
				{rowList.map(row => {
					return (
						<div class="c-schedule-row">
							<div class="c-schedule-label">{row.label}</div>
							<div class="c-schedule-value" onClick={() => row.onClick && row.onClick()}>
								<span
									style={{ color: row.color, cursor: row.onClick ? 'pointer' : 'auto' }}
									class={{ 'c-schedule-span--underline': row.onClick }}
								>
									{row.value || '-'}
								</span>
							</div>
						</div>
					);
				})}
			</div>
		);
	}
};
</script>

<style lang="less" scoped>
.c-schedule-wrapper {
	.c-schedule-row {
		display: flex;

		& + .c-schedule-row {
			margin-top: 4px;
		}
		.c-schedule-label {
			width: 70px;
			color: var(--secondary-info-color);

			font-size: 12px;

			font-weight: 400;
			line-height: 16px; /* 133.333% */
		}
		.c-schedule-value {
			flex: 1;
			width: 0;
			display: flex;
			align-items: center;

			span {
				color: var(--emphasis-color);

				font-size: 12px;

				font-weight: 400;
				line-height: 16px; /* 133.333% */
				cursor: pointer;
				word-break: break-all;
			}
			.c-schedule-span--underline {
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
}
</style>
